import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type InviteProgramBody = {
  program: {
    community_ids: string[];
    organization_ids: string[];
    user_ids: string[];
  };
};

type InviteProgramRouteParams = {
  programId: string;
};

export const inviteProgram = async ({
  body,
  routeParams: { programId },
}: BodyRouteParamsRequest<InviteProgramBody, InviteProgramRouteParams>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.program.invite(programId), body);
